import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import MainBody from "../../../component/MainBody";
import httpRequest from "../../../utils/Http";
import { toast } from "react-toastify";
import { LABEL_JOB } from "../../../constant/label_constant";
import Select from "react-select";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { getFilteredTimeslots } from "../../../utils/HelperFunction";

const BookingReschedule = () => {
  const navigate = useNavigate();
  const [isSubmit, setSubmit] = useState(false);
  const [formData, setFormData] = useState({});
  const [formErrors, setFormErrors] = useState({});
  const [rescheduleList, setRescheduleList] = useState([]);
  const [appointmentDate, setAppointmentDate] = useState();
  const [timeslotList, setTimeslotList] = useState([]);

  const { id } = useParams();

  useEffect(() => {
    if (formData?.appointment_date) {
      setTimeslotList(getFilteredTimeslots(formData.appointment_date));
    }
  }, [formData?.appointment_date]);

  useEffect(() => {
    (async () => {
      if (id) {
        const bid = atob(id);
        const data = await httpRequest("getcalldetails?id=" + bid, {}, "GET");

        if (data.status === true) {
          if (
            !data.bookingData.sc_closed_date &&
            !data.bookingData.closed_date
          ) {
            setFormData({
              ...formData,
              booking_id: data.bookingData.booking_id,
              id: data.bookingData.id,
            });
          } else {
            toast.error(
              `${LABEL_JOB} already closed. You can not allow to reschedule booking`,
            );
            navigate("/pendingbooking");
          }
        } else {
          toast.error(`${LABEL_JOB} Not Found`);
          navigate("/404");
        }
      } else {
        toast.error(`${LABEL_JOB} Not Found`);
        navigate("/404");
      }
    })();
  }, [id]);

  useEffect(() => {
    (async () => {
      const reschedule = await httpRequest(
        "getreschedulereasonlist?is_active=1",
        {},
        "GET",
      );
      if (reschedule.status === true && reschedule.data) {
        setRescheduleList(reschedule.data["rows"]);
      }
    })();
  }, []);

  const onSubmitHandler = (e) => {
    e.preventDefault();
    setSubmit(false);
    setFormErrors(validateFrom(formData));
    setSubmit(true);
  };

  const validateFrom = (value) => {
    const errors = {};
    //console.log(value);
    if (!value.rescheduled_id) {
      errors.rescheduled_id = "Reschedule Reason is Required";
    }

    if (!value.remarks) {
      errors.remarks = "Remarks is Required";
    }
    if (!value.appointment_date) {
      errors.appointment_date = "Appointment is Required";
    }

    if (!value.timeslot) {
      errors.timeslot = "Timeslot is Required";
    }

    return errors;
  };

  useEffect(() => {
    (async () => {
      if (Object.keys(formErrors).length === 0 && isSubmit) {
        const data = await httpRequest(
          "processreschedulebooking",
          formData,
          "POST",
        );

        setSubmit(false);
        if (data.status === true && data.message) {
          document.getElementById("reschedule").reset();
          toast.success(data.message);
          navigate("/pendingbooking");
        } else {
          toast.error(data.message);
        }
      }
    })();
    //eslint-disable-next-line
  }, [isSubmit, formErrors]);

  return (
    <div>
      <MainBody
        breadcrumbTitle="Reschedule Booking"
        breadcrumbSubTitle={formData.booking_id}
        navButton={""}
        title={""}
        component={
          <>
            <section className="content">
              <div className="container-fluid">
                <form
                  className="form-horizontal booking-action-form"
                  id="reschedule"
                  onSubmit={onSubmitHandler}
                >
                  <div className="card card-default booking-action-card">
                    <div className="card-header booking-action-header">
                      <h3 className="card-title">Reschedule Booking</h3>
                    </div>
                    <div className="card-body booking-action-body">
                      <div className="row booking-action-grid">
                        <div className="col-md-12 booking-action-stack">
                          <div className="form-group row booking-action-row">
                            <label
                              htmlFor="bookingid"
                              className="col-md-2 col-form-label booking-action-label"
                            >
                              {LABEL_JOB} Id{" "}
                              <span className="required-mark">*</span>
                            </label>
                            <div className="col-md-4 booking-action-field">
                              <input
                                type="text"
                                className="form-control"
                                id="bookingid"
                                placeholder="Enter Booking Id"
                                name="bookingid"
                                value={formData.booking_id}
                                readOnly={true}
                              />
                              {formErrors.bookingid && (
                                <span className="booking-action-error">
                                  {formErrors.bookingid}
                                </span>
                              )}
                            </div>
                          </div>

                          <div className="form-group row booking-action-row">
                            <label
                              htmlFor="rescheduled_id"
                              className="col-md-2 col-form-label booking-action-label"
                            >
                              Reschedule Reason{" "}
                              <span className="required-mark">*</span>
                            </label>
                            <div className="col-md-4 booking-action-field">
                              <div className="select2-purple">
                                <Select
                                  name="rescheduled_id"
                                  placeholder="Select Reschedule Reason"
                                  value={
                                    rescheduleList.find(
                                      (option) =>
                                        option.value ===
                                        formData.rescheduled_id,
                                    ) || null
                                  }
                                  options={rescheduleList}
                                  onChange={(val) => {
                                    setFormData({
                                      ...formData,
                                      rescheduled_id: val.value,
                                    });
                                  }}
                                  classNamePrefix="select2-purple"
                                />
                              </div>
                              {formErrors.rescheduled_id && (
                                <span className="booking-action-error">
                                  {formErrors.rescheduled_id}
                                </span>
                              )}
                            </div>
                          </div>

                          <div className="form-group row booking-action-row">
                            <label
                              htmlFor="appointment_date"
                              className="col-md-2 col-form-label booking-action-label"
                            >
                              Appointment Date{" "}
                              <span className="required-mark">*</span>
                            </label>
                            <div className="col-md-4 booking-action-field">
                              <DatePicker
                                className="form-control text-capitalize"
                                minDate={new Date()}
                                dateFormat="dd/MM/yyyy"
                                selected={appointmentDate}
                                placeholderText="Select Appointment Date"
                                onChange={(date) => {
                                  setFormData({
                                    ...formData,
                                    appointment_date: date,
                                  });
                                  setAppointmentDate(date);
                                }}
                              />
                              {formErrors.appointment_date && (
                                <span className="booking-action-error">
                                  {formErrors.appointment_date}
                                </span>
                              )}
                            </div>
                          </div>

                          <div className="form-group row booking-action-row">
                            <label
                              htmlFor="timeslot"
                              className="col-md-2 col-form-label booking-action-label"
                            >
                              Timeslot <span className="required-mark">*</span>
                            </label>
                            <div className="col-md-4 booking-action-field">
                              <div className="select2-purple">
                                <Select
                                  name="timeslot"
                                  placeholder="Select Timeslot"
                                  value={
                                    timeslotList.find(
                                      (option) =>
                                        option.value === formData.timeslot,
                                    ) || null
                                  }
                                  options={timeslotList}
                                  onChange={(val) => {
                                    setFormData({
                                      ...formData,
                                      timeslot: val.value,
                                    });
                                  }}
                                  classNamePrefix="select2-purple"
                                />
                              </div>
                              {formErrors.timeslot && (
                                <span className="booking-action-error">
                                  {formErrors.timeslot}
                                </span>
                              )}
                            </div>
                          </div>

                          <div className="form-group row booking-action-row">
                            <label
                              htmlFor="remarks"
                              className="col-md-2 col-form-label booking-action-label"
                            >
                              Remarks <span className="required-mark">*</span>
                            </label>
                            <div className="col-md-4 booking-action-field">
                              <textarea
                                type="text"
                                className="form-control"
                                id="remarks"
                                placeholder="Enter Remarks"
                                name="remarks"
                                onChange={(e) => {
                                  setFormData({
                                    ...formData,
                                    [e.target.name]: e.target.value,
                                  });
                                }}
                              />
                              {formErrors.remarks && (
                                <span className="booking-action-error">
                                  {formErrors.remarks}
                                </span>
                              )}
                            </div>
                          </div>

                          <div className="form-group row booking-action-row booking-action-submit-row">
                            <div className="offset-sm-2 col-sm-10 booking-action-submit-wrap">
                              <button
                                type="submit"
                                className="btn btn-primary booking-action-submit-btn"
                              >
                                Submit
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </section>
          </>
        }
      />
    </div>
  );
};

export default BookingReschedule;
